import '.j1{display:inline-block;}.ssr-plugin'
import '.j2{margin-top:1.5rem;}.ssr-plugin'
import '.c4{font-size:0.875rem;}.ssr-plugin'
import '.j3{color:var(--palette-blue-500);}.ssr-plugin'
import '.i0{text-decoration:underline;}.ssr-plugin'
import { useEffect, useState } from 'react'
import { styled } from 'inlines'

export type DiscoveryCrawlerPaginationFooterProps = {
  nextPageHref: string | null
}

export const DiscoveryCrawlerPaginationFooter = ({
  nextPageHref,
}: DiscoveryCrawlerPaginationFooterProps) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!nextPageHref || mounted) {
    return null
  }

  return (
    <a className="j1 j2 c4 j3 i0"
      rel="next"
      href={nextPageHref}
    >
      next page
    </a>
  )
}
